export enum DashboardInstallationUrls {
  List = 'installations',
  Board = 'board',
  Map = 'map',
}
